import { useState, useCallback, useEffect } from 'react';
import { useThemeMediaQuery } from '@hooks/useThemeMediaQuery';
import { AUTO_PLAY_INTERVAL } from './WeddingSuiteSection.constants';

export const useWeddingSuiteSectionController = (numberOfSlides: number) => {
  const isMobile = useThemeMediaQuery('below_sm');
  const [isMobileDevice, setIsMobileDevice] = useState(false);
  const [activeSlide, setActiveSlide] = useState(0);
  const [isLastSlide, setIsLastSlide] = useState(false);
  const [isSliding, setIsSliding] = useState(false);
  const [isScrolledIntoView, setIsScrolledIntoView] = useState(false);
  const handleBeforeSlide = useCallback(
    (_currentSlide: number, nextSlide: number) => {
      if (isMobile) {
        setActiveSlide(nextSlide);
      }

      setIsSliding(true);
    },
    [isMobile]
  );
  const handleAfterSlide = useCallback(
    (prevSlide: number) => {
      setIsLastSlide(numberOfSlides === prevSlide + 1 && !!isMobile);
      setIsSliding(false);
    },
    [isMobile, numberOfSlides]
  );
  const handleChangeSlide = useCallback(
    (typeOfButton: 'prev' | 'next') => {
      if (isSliding) {
        return;
      }

      const isFirst = activeSlide === 0;
      const isLast = activeSlide === numberOfSlides - 1;

      if (typeOfButton === 'prev') {
        setActiveSlide(isFirst ? numberOfSlides - 1 : activeSlide - 1);
      }

      if (typeOfButton === 'next') {
        setActiveSlide(isLast ? 0 : activeSlide + 1);
      }
    },
    [activeSlide, isSliding, numberOfSlides]
  );
  useEffect(() => {
    let timeout: ReturnType<typeof setTimeout>;
    if (isLastSlide) {
      timeout = setTimeout(() => setActiveSlide(0), AUTO_PLAY_INTERVAL);
    }
    return () => {
      clearTimeout(timeout);
    };
  }, [isLastSlide]);
  useEffect(() => setIsMobileDevice(Boolean(isMobile)), [isMobile]);
  return {
    isMobileDevice,
    activeSlide,
    isScrolledIntoView,
    setIsScrolledIntoView,
    handleChangeSlide,
    handleBeforeSlide,
    handleAfterSlide,
  };
};
